import axios from "axios";
import { makeUrl, getItem } from "../../app/common/util/genericUtils";

const authHeaders = () => {
  const user = getItem("suprolUser");
  return {
    Authorization: `Token ${user.auth_token}`,
  };
};

export const getWhatsappStatusApiCall = () => {
  return axios({
    method: "GET",
    url: makeUrl("/whatsapp/status"),
    headers: authHeaders(),
  });
};

export const getWhatsappQrApiCall = () => {
  return axios({
    method: "GET",
    url: makeUrl("/whatsapp/qr"),
    headers: authHeaders(),
  });
};

export const logoutWhatsappApiCall = () => {
  return axios({
    method: "POST",
    url: makeUrl("/whatsapp/logout"),
    headers: authHeaders(),
  });
};
